/* unplugin-vue-components disabled */import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//

import SmyFullPopup from './SmyFullPopup';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Search from "vux/src/components/search/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import AMap from 'AMap';
export default {
  name: 'GaoDeMap',
  directives: {
    TransferDom: TransferDom
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    center: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SmyFullPopup: SmyFullPopup,
    ViewBox: ViewBox,
    Search: Search
  },
  watch: {
    value: function value(val) {
      this.isShow = val;
      // if (val && this.center.length > 0) {
      //   this.tomap() // 居中
      // }
    },
    isShow: function isShow(v) {
      this.$emit('input', v);
    }
  },
  data: function data() {
    return {
      isShow: this.value
    };
  },
  computed: {
    src: function src() {
      return "https://m.amap.com/picker/?center=".concat(this.center.join(','), "&key=4a1b93f9d1eb22bb4fa99070ed8f50f8");
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.loadmap();
    });
  },
  methods: {
    callback: function callback(arr, add) {
      this.$emit('callback', {
        position: arr,
        address: add
      });
      this.isShow = false;
    },
    loadmap: function loadmap() {
      var _this2 = this;
      var mapView = this.$refs.mapView;
      var iframe = mapView.contentWindow;
      mapView.onload = function () {
        iframe.postMessage('hello', 'https://m.amap.com/picker/');
      };
      window.addEventListener('message', function (e) {
        if (e.data.location) {
          var position = [e.data.location.split(',')[0], e.data.location.split(',')[1]];
          var address = e.data.address;
          _this2.$emit('callback', {
            position: position,
            address: address
          });
          _this2.isShow = false;
        }
      }, false);
    },
    tomap: function tomap() {
      this.src = "https://m.amap.com/picker/?center=".concat(this.center.join(','), "&key=4a1b93f9d1eb22bb4fa99070ed8f50f8");
      this.$refs.mapView.setAttribute('src', this.src);
    }
  }
};